import { SET_ACTIVE_ROUTE, ROUTES } from "../../actions/app/constants";

const defaultState = {
  activeRoute: ROUTES.PLACEMENT_LIST
};

export const navigation = (state = defaultState, action) => {
  switch (action.type) {
    case SET_ACTIVE_ROUTE:
      return { ...state, activeRoute: action.route };
    default:
      return state;
  }
};
